const FETCH_GENRES = 'studio/storyCreateEdit/FETCH_GENRES';
const CREATE_STORY = 'studio/storyCreateEdit/CREATE_STORY';
const EDIT_STORY = 'studio/storyCreateEdit/EDIT_STORY';
const REMOVE_STORY = 'studio/storyCreateEdit/REMOVE_STORY';
const CRATE_TAG = 'studio/storyCreateEdit/CREATE_TAG';
const FETCH_SEARCH_TAGS = 'studio/storyCreateEdit/FETCH_SEARCH_TAGS';
const FETCH_RECOMMENDED_TAGS = 'studio/storyCreateEdit/FETCH_RECOMMENDED_TAGS';
const RESET = 'studio/storyCreateEdit/RESET';
const FETCH_CATEGORIES = 'studio/storyCreateEdit/FETCH_CATEGORIES';

export default {
  FETCH_GENRES,
  CREATE_STORY,
  EDIT_STORY,
  REMOVE_STORY,
  CRATE_TAG,
  FETCH_SEARCH_TAGS,
  FETCH_RECOMMENDED_TAGS,
  RESET,
  FETCH_CATEGORIES,
};



// WEBPACK FOOTER //
// ./src/app/redux/studio/storyCreateEdit/types.js